import { Condition } from "@redotech/redo-model/return-flow/condition";
import { validateCustomerSmsSubscriberCondition } from "@redotech/redo-model/return-flow/condition-validate";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export type CustomerSmsSubscriberState = void;

export const CUSTOMER_SMS_SUBSCRIBER = (
  Details: React.ComponentType<
    ConditionTypeDetailsProps<CustomerSmsSubscriberState>
  >,
): ConditionType<
  CustomerSmsSubscriberState,
  Condition.CustomerSmsSubscriber
> => ({
  name: "Customer sms subscriber",
  description() {
    return "Customer is an sms subscriber";
  },
  Details(props: ConditionTypeDetailsProps<CustomerSmsSubscriberState>) {
    return React.createElement(Details, props);
  },
  empty: undefined,
  fromModel() {},
  toModel() {
    return { type: Condition.CUSTOMER_SMS_SUBSCRIBER };
  },
  valid() {
    return validateCustomerSmsSubscriberCondition({}).valid;
  },
});
